import Request from "../constants/Request.api"
import Api from "../Api"

class Admin extends Api {
  addStaff = user => {
    const request = new Request({
      data: {
        ...user,
        url: "staff",
      },
    })

    return this.postRequest(request)
  }

  updateStaff = user => {
    const request = new Request({
      data: {
        ...user,
        url: "staff/" + user.id,
      },
    })

    return this.putRequest(request)
  }

  getStaffDetails = user => {
    const request = new Request({
      data: {
        url: "staff/" + user.id,
      },
    })

    return this.getRequest(request)
  }

  getAllStaff = () => {
    const request = new Request({
      data: {
        url: "staff/all",
      },
    })

    return this.getRequest(request)
  }

  getPermissions = () => {
    const request = new Request({
      data: {
        url: "staff/permissions/all",
      },
    })

    return this.getRequest(request)
  }

  getDepartments = () => {
    const request = new Request({
      data: {
        url: "departments",
      },
    })

    const response = this.getRequest(request)
    return response
  }

  getPositions = () => {
    const request = new Request({
      data: {
        url: "staff/positions/all",
      },
    })

    return this.getRequest(request)
  }

  getConsumptionAreas = () => {
    const request = new Request({
      data: {
        url: "plastics/consumption-areas",
      },
    })

    return this.getRequest(request)
  }

  getConsumptionAreaItems = (id) => {
    const request = new Request({
      data: {
        url: "plastics/consumption-areas/" + id,
      },
    })

    return this.getRequest(request)
  }

  addConsumptionArea = (areaName) => {
    const data = {
      name: areaName,
      url: "plastics/consumption-areas"
    }

    const request = new Request({
      data: data
    })

    return this.postRequest(request)
  }
  
  addConsumptionAreaItem = (areaId, itemName) => {
    const data = {
      consumption_area_id: areaId,
      name: itemName,
      is_endorsed: true,
      url: "plastics/consumption-area-item"
    }

    const request = new Request({
      data: data
    })

    return this.postRequest(request)
  }

  getConsumptionArea = (areaId) => {
    const request = new Request({
      data: {
        url: "plastics/consumption-area/" + areaId,
      },
    })

    return this.getRequest(request)
  }

  
}

export default Admin
